<tec-modal
	[isVisible]="true"
	[title]="'WORKFLOWS.DUPLICATE_TO_ENV.TITLE' | translate"
	[buttonPrimaryLabel]="'BUTTON.CONTINUE' | translate"
	[buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
	(closeEvent)="closeModal($event)"
>
	<ng-container body [formGroup]="form">
		@if (errorMsg) {
			<tec-alert status="error" [msg]="errorMsg" (closeAlert)="errorMsg = ''" />
		}

		<p class="duplicate-to-env__intro">
			{{ 'WORKFLOWS.DUPLICATE_TO_ENV.INTRO' | translate: { name: workflow.alias } }}
		</p>

		<tec-form-group
			[label]="'WORKFLOWS.DUPLICATE_TO_ENV.SELECT_ENV' | translate"
			[errorMsg]="reactiveFormService.hasMsgError(form.get('target_env'))"
		>
			<tec-select
				formControlName="target_env"
				[placeholder]="'WORKFLOWS.DUPLICATE_TO_ENV.SELECT_ENV_PLACEHOLDER' | translate"
				[options]="environmentOptions"
				[hasError]="reactiveFormService.hasError(form.get('target_env'))"
			/>
		</tec-form-group>

		<tec-alert
			status="default"
			hiddenCloseButton
			[msg]="'WORKFLOWS.DUPLICATE_TO_ENV.AUTO_CREATE_INFO' | translate"
		/>
	</ng-container>
</tec-modal>
